import React from "react";

interface Tab {
  id: string;
  label: string;
  active?: boolean;
}

interface TabNavigationProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

const TabNavigation: React.FC<TabNavigationProps> = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
      <div className="px-4 md:px-6">
        <nav className="flex flex-wrap gap-x-2 md:gap-x-6">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              onClick={() => onTabChange(tab.id)}
              className={`py-4 px-3 md:px-4 border-b-2 text-sm transition-colors font-semibold ${
                activeTab === tab.id
                  ? "border-cyan-500 text-cyan-600 bg-indigo-50/60"
                  : "border-transparent text-gray-800 hover:text-gray-900 hover:border-gray-300"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default TabNavigation;
